(function (angular, parseInt) {
  "use strict";

  var RESTORE_OVERFLOW_ANCHOR_TIMEOUT_MS = 100;

  angular.module("Toyota.Services").service("StickToTopManager", [
    "$window",
    "ScrollLock",
    function ($window, ScrollLock) {
      var exports = this;
      var restoreOverflowAnchorTimeout = null;
      var managedElements = [];

      function createPlaceholderElement(extraCssClasses) {
        return angular.element('<div class="' + (extraCssClasses || "") + ' ty-stick-to-top-placeholder"></div>');
      }

      function getElementHeightInclMargins($el) {
        var boundingRect = $el.get(0).getBoundingClientRect();
        var rawHeight = boundingRect.bottom - boundingRect.top;
        var marginTop = parseInt($el.css("margin-top").match(/([0-9]+(\.[0-9])?)/g)[0], 10);
        var marginBottom = parseInt($el.css("margin-bottom").match(/([0-9]+(\.[0-9])?)/g)[0], 10);
        return rawHeight + marginTop + marginBottom;
      }

      function getSumOfPreviousPlaceholderHeights($placeholder) {
        var allPlaceholders = angular.element(".ty-stick-to-top-placeholder").toArray();
        var previousPlaceholders = allPlaceholders.slice(0, allPlaceholders.indexOf($placeholder.get(0)));
        var sumOfPreviousPlaceholderHeights = 0;
        angular.forEach(previousPlaceholders, function (el) {
          sumOfPreviousPlaceholderHeights += getElementHeightInclMargins(angular.element(el));
        });
        return sumOfPreviousPlaceholderHeights;
      }

      function calculateRepaintState(managedElement) {
        var repaintState = {};

        var sumOfPreviousPlaceholderHeights = getSumOfPreviousPlaceholderHeights(managedElement.$placeholder);

        repaintState.isPlaceholderTopOutsideViewport =
          managedElement.$placeholder.get(0).getBoundingClientRect().top < sumOfPreviousPlaceholderHeights;
        repaintState.isFixed = repaintState.isPlaceholderTopOutsideViewport;

        repaintState.topWhenFixed = sumOfPreviousPlaceholderHeights;

        angular.extend(repaintState, managedElement.repaintStateOverrides);

        return repaintState;
      }

      function setPlaceholderVisibility(managedElement, visible) {
        managedElement.$placeholder.css({
          height: visible ? getElementHeightInclMargins(managedElement.$element) + "px" : "0",
          visibility: visible ? "" : "hidden",
        });
      }

      function applyRepaintState(managedElement) {
        var $element = managedElement.$element;
        var repaintState = managedElement.repaintState;

        var $html = angular.element("html");
        $html.css("overflow-anchor", "none");
        $window.clearTimeout(restoreOverflowAnchorTimeout);

        if (repaintState.isFixed) {
          /*
           * fix the element to the viewport, the same offset from the top. (this should stop it from actually moving anywhere)
           * transform translate3d forces ipad to load position fixed on scroll
           */
          $element.css({
            position: "fixed",
            top: repaintState.topWhenFixed,
            transform: "translate3d(0,0,0)",
          });
        } else {
          // put the nav back where it was
          $element.css({
            position: "",
            top: 0,
            transform: "translate3d(0,0,0)",
          });
        }

        // Note that setRepaintOverrides may override isFixed independently from isPlaceholderTopOutsideViewport
        setPlaceholderVisibility(managedElement, repaintState.isPlaceholderTopOutsideViewport || repaintState.isFixed);

        restoreOverflowAnchorTimeout = $window.setTimeout(function () {
          $html.css("overflow-anchor", "");
        }, RESTORE_OVERFLOW_ANCHOR_TIMEOUT_MS);
      }

      function calculateAndRepaint(managedElement) {
        if (ScrollLock.isLocked) {
          return;
        }

        managedElement.repaintState = calculateRepaintState(managedElement);
        applyRepaintState(managedElement);
      }

      function setRepaintOverrides(managedElement, newRepaintStateOverrides) {
        managedElement.repaintStateOverrides = newRepaintStateOverrides;
        calculateAndRepaint(managedElement);
      }

      function clearRepaintOverrides(managedElement) {
        exports.setRepaintStateOverrides(managedElement, null);
      }

      exports.element = function ($element) {
        return managedElements.find(function (managedElement) {
          return managedElement.$element.get(0) === $element.get(0);
        });
      };

      exports.setupElement = function ($element, extraPlaceholderCssClasses) {
        // put in a placeholder element to take up the space the initial element took up
        var $placeholder = createPlaceholderElement(extraPlaceholderCssClasses);

        var managedElement = {
          $element: $element,
          $placeholder: $placeholder,
          repaintState: null,
          repaintStateOverrides: null,
          repaint: function () {
            calculateAndRepaint(managedElement);
          },
          setRepaintStateOverrides: function (newRepaintStateOverrides) {
            setRepaintOverrides(managedElement, newRepaintStateOverrides);
          },
          clearRepaintStateOverrides: function () {
            clearRepaintOverrides(managedElement);
          },
          teardown: function () {
            exports.teardownElement(managedElement);
          },
        };

        managedElements.push(managedElement);

        angular.element($window).on("scroll", managedElement.repaint);
        angular.element($window).on("resize", managedElement.repaint);

        $element.before($placeholder);
        managedElement.repaint();

        return managedElement;
      };

      exports.teardownElement = function (managedElement) {
        managedElement.$placeholder.remove();

        angular.element($window).off("scroll", managedElement.repaint);
        angular.element($window).off("resize", managedElement.repaint);
      };

      exports.getFixedBottomEdge = function () {
        var fixedElements = managedElements.filter(function (managedElement) {
          return managedElement.repaintState.isFixed;
        });

        var bottomEdge = fixedElements.reduce(function (bottomEdge, managedElement) {
          return Math.max(
            bottomEdge,
            managedElement.repaintState.topWhenFixed + getElementHeightInclMargins(managedElement.$placeholder)
          );
        }, 0);

        return bottomEdge;
      };

      /*
       * This is here because if you're scrolled to the top, nothing is fixed so the
       * function above will return 0.
       */
      exports.getManagedElementsCombinedHeight = function () {
        var combinedHeight = managedElements.reduce(function (combinedHeight, managedElement) {
          var boundingClientRect = managedElement.$element.context.getBoundingClientRect();
          return combinedHeight + boundingClientRect.bottom - boundingClientRect.top;
        }, 0);

        return combinedHeight;
      };

      return exports;
    },
  ]);
})(window.angular, window.parseInt);
